import React from 'react';
import {Button, ButtonGroup} from "react-bootstrap";

const Row = ({ partner, onUpdate, onRemove }) => {
    return (<tr>
        <td>{partner.name}</td>
        <td>{partner.auth}</td>
        <td>{partner.costCalculationMethod}</td>
        <td>{partner.partnerDomainType}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="primary" onClick={() => onUpdate(partner)}>Update</Button>
                <Button bsStyle="danger" onClick={() => onRemove(partner.id)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartners/components/Table/components/Row/index.js